import { WalletIcon } from '@/components/atoms/WalletIcon/WalletIcon'
import { Flex } from 'antd'
import React, { MouseEvent } from 'react'
import styles from './MobileWalletButton.module.scss'

type Props = {
  icon: string;
  onClick: (event: MouseEvent) => void;
  title: string;
}

export function MobileWalletButton({ icon, title, onClick }: Props) {
  return (
    <a onClick={onClick} className={styles.root}>
      <Flex gap={16} align="center">
        <WalletIcon wallet={icon} width="48px" height="48px" />
        <span>{title}</span>
      </Flex>
    </a>
  )
}
